import { render, staticRenderFns } from "./OrganizeCosts.vue?vue&type=template&id=06316a16&scoped=true&"
import script from "./OrganizeCosts.vue?vue&type=script&lang=js&"
export * from "./OrganizeCosts.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeCosts.vue?vue&type=style&index=0&id=06316a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06316a16",
  null
  
)

export default component.exports